/* eslint-disable no-param-reassign */

import isAfter from 'date-fns/isAfter';
import { formatDate } from './date';

export const selectCheapestCourse = (courses) => {
  let count = Number.MAX_SAFE_INTEGER;
  let id;

  courses.map((course) => {
    course.selected = false;
    course.priceRanges.map((pr) => {
      pr.selected = false;
      if (pr.exchanged < count) {
        id = course.id;
        count = pr.exchanged;
      }
    });
  });

  return SelectCourse(courses, id);
};

export const selectCheapestCourseByWeeks = (courses, weeks) => {
  const coursesByWeeks = [];

  courses.map((course) => {
    course.priceRanges.map((pr) => {
      const isWithinReach =
        parseInt(weeks, 10) >= pr.rangeFrom &&
        parseInt(weeks, 10) <= pr.rangeTo;

      if (isWithinReach) coursesByWeeks.push(course);
    });
  });

  return selectCheapestCourse(coursesByWeeks);
};

export const SelectCourse = (courses, id, weekQuantity = null) => {
  courses.map((course) => {
    let weeksInRange = true;

    if (weekQuantity) {
      weeksInRange = course.priceRanges.some(
        (pr) => pr.rangeFrom <= weekQuantity && pr.rangeTo >= weekQuantity
      );
    }

    const selectedId = course.id === parseInt(id, 10);

    course.selected = selectedId && weeksInRange;
    if (selectedId) {
      course.priceRanges.map((pr) => {
        pr.selected = weeksInRange && true;
      });
    }
  });

  return courses;
};

export const getSelectedCourseId = (courses) => {
  let id;

  courses.map((course) => {
    if (course.selected) id = course.id;
  });

  return id;
};

export const getSelectedCoursePriceRangeId = (courses) => {
  let id;

  courses.map((course) => {
    if (course.selected)
      course.priceRanges.map((pr) => {
        if (pr.selected) id = pr.id;
      });
  });

  return id;
};

export const getSelectedCourses = (courses) =>
  courses.filter((d) => d.selected === true);

export const courseTotalPrices = (course) => {
  const currentPriceRange = course.priceRanges[0];
  const exchangeRate = currentPriceRange.exchangeRateUsed;
  const registrationFee = course.registrationFee / exchangeRate;
  const registrationFeeWithDiscount =
    course.registrationFeeWithDiscount / exchangeRate;
  const registrationFeeExchanded = course.registrationFee;
  const registrationFeeWithDiscountExchanged =
    course.registrationFeeWithDiscount;

  const bookMaterialPriceExchanged = course.bookChargedBefore
    ? course.bookMaterial.exchanged
    : 0;
  const bookMaterialPrice = course.bookChargedBefore
    ? course.bookMaterial.price
    : 0;

  const price = currentPriceRange.price + registrationFee + bookMaterialPrice;
  const priceWithDiscount =
    currentPriceRange.total + registrationFeeWithDiscount + bookMaterialPrice;
  const priceExchanged =
    currentPriceRange.exchanged +
    registrationFeeExchanded +
    bookMaterialPriceExchanged;
  const priceWithDiscountExchanged =
    currentPriceRange.totalExchanged +
    registrationFeeWithDiscountExchanged +
    bookMaterialPriceExchanged;

  const discount = priceExchanged - priceWithDiscountExchanged;
  const [courseSupplementExchanged] = course?.priceRanges.map(
    ({ supplementExchanged }) => supplementExchanged
  );

  return {
    bookChargedBefore: course.bookChargedBefore,
    bookMaterial: course.bookMaterial,
    bookNote: course.bookNote,
    courseSupplementExchanged,
    discount: discount > 0 ? discount : 0,
    exchangeRate,
    price,
    priceExchanged,
    priceWithDiscount,
    priceWithDiscountExchanged,
    registrationFee,
    registrationFeeExchanded,
    registrationFeeWithDiscount,
    registrationFeeWithDiscountExchanged,
    supplement: getSupplementValueByCourse(course),
    total: price,
    totalDiscount: priceWithDiscount,
    totalDiscountExchanged: priceWithDiscountExchanged,
    totalExchanged: priceExchanged,
  };
};

export const courseTotalPricesToCheckout = (checkout) => {
  const currentPriceRange = checkout.courses[0].value;
  const { registrationFeeWithDiscountExchanged } = checkout;
  const exchangeRate = currentPriceRange?.exchangeRateUsed;

  const bookMaterialPriceExchanged = checkout.bookChargedBefore
    ? checkout.courses[0]?.bookMaterialPriceExchanged
    : 0;

  const priceExchanged =
    currentPriceRange.exchanged +
    checkout.registrationFeeExchanded +
    bookMaterialPriceExchanged;
  const priceWithDiscountExchanged =
    currentPriceRange.totalExchanged +
    registrationFeeWithDiscountExchanged +
    bookMaterialPriceExchanged;

  const discount = priceExchanged - priceWithDiscountExchanged;
  checkout.totalExchanged = priceExchanged;

  return {
    discount: discount > 0 ? discount : 0,
    exchangeRate,
    totalExchanged: priceExchanged,
  };
};

export const getSupplementValueByCourse = (course) => {
  let supplement = 0;

  course.priceRanges.map((pr) => {
    pr.supplements.map((s) => {
      supplement += s.price;
    });
  });

  return supplement;
};

export const getUpcomingStartDatesText = (startDates) => {
  if (startDates.length === 0) return 'Inicia toda segunda-feira';

  let startDatesText = '';

  startDates.forEach((date, index) => {
    if (isAfter(new Date(date), new Date())) {
      startDatesText += `${formatDate(date, 'forward-slash')}`;
      startDatesText += startDates.length === index + 1 ? '.' : ', ';
    }
  });

  return startDatesText;
};

export const getBreakDates = (breakDates) => {
  let breakDatesText = 'a escola não funciona no periodo de: ';

  if (breakDates && breakDates.length > 0) {
    breakDates.map((date) => {
      breakDatesText = `${breakDatesText} ${formatDate(date, 'forward-slash')}`;
    });
  }

  return breakDatesText;
};

export const verifyPriceRangesByWeeks = (courses, weeks) => {
  let priceRangeMatch = false;

  courses.map((course) => {
    course.priceRanges.map((pr) => {
      if ((pr.rangeTo === pr.rangeFrom) === weeks) priceRangeMatch = true;
    });
  });

  return priceRangeMatch;
};
